import React from 'react';
import { Routes, Route } from "react-router-dom";
import "@arcgis/core/assets/esri/themes/light/main.css";
import './App.css';

import GisDashboard from './components/GisDashboard/Gis_Dash';




function App() {
  return (
  <GisDashboard />

  );
}

export default App;
